import {Component, OnInit} from '@angular/core';
import {ButtonInvoke} from "../../shared/panel-buttons/panel-buttons.component";
import {UcetniJednotkaCreateDetailService} from "../ucetni-jednotka-create-detail.service";
import {UcetniObdobiEmitData} from "../../ucetni-obdobi-data/models/UcetniObdobiDtos";



@Component({
    selector: 'cml-uj-detail-component',
    templateUrl: './ucetni-jednotka-detail.component.html',
    styleUrls: ['./ucetni-jednotka-detail.component.scss'],
    standalone: false
})
export class UcetniJednotkaDetailComponent implements OnInit
{
  buttons: ButtonInvoke[] = [];

  constructor(private detailServ: UcetniJednotkaCreateDetailService) {
  }
  ngOnInit()
  {
   this.createToolBarButtons()
  }
  createToolBarButtons()
  {
    this.buttons = this.detailServ.createToolbarButtons()
  }

  definiceLoaded(event: any){
    this.detailServ.definiceUcetniJednotky = event
  }
  ucetniObdobiLoaded(event: UcetniObdobiEmitData){
    this.detailServ.ucetniObdobiJednotky = event.ucetniObdobi
    this.detailServ.ucetniObdobiTableColumns = event.fields
  }
}
